<template>    
  <v-app>     
    <div style="height:100vh; overflow-y: auto">      
      <v-content>        
        <div id="login" class="green"></div>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs9 sm5 md4 lg3>
              <v-card class="elevation-1">
                <v-btn class="green darken-4 ma-3" dark large icon href="#/" absolute><v-icon>arrow_back</v-icon></v-btn>
                <v-card-text class="px-4">                  
                  <div class="layout column align-center mb-3">
                    <img src="@/assets/logo.png" alt="Vue Material Admin" height="80">                                      
                    <br/>
                    <h3 class="green--text">Login - Masuk</h3>
                  </div>                
                  <v-form>
                    <v-text-field append-icon="contact_phone" name="login" label="Username/Phone" type="text" v-model="model.username"></v-text-field>
                    <v-text-field hide-details                       
                      name="password" 
                      label="Password" 
                      id="password" 
                      v-model="model.password" 
                      @keyup.enter="login"                      
                      :append-icon="show3 ? 'visibility' : 'visibility_off'"                    
                      :type="show3 ? 'text' : 'password'"
                      @click:append="show3 = !show3"                    
                    ></v-text-field>                    
                    <!--<v-text-field class="mt-3" name="captcha" @keyup.enter="login" label="Captcha" type="text" v-model="model.captcha" hide-details>
                      <template slot="append">
                        <v-fade-transition leave-absolute>
                          <v-progress-circular
                            v-if="!captcha"
                            size="24"
                            width="2"
                            color="info"
                            indeterminate
                          ></v-progress-circular>
                          <img class="cursor" @click="getCaptcha()" v-else :src="captcha" alt="">
                        </v-fade-transition>
                      </template>                      
                    </v-text-field>-->
                    
                  </v-form>
                </v-card-text>
                <v-card-actions class="pa-4">
                  <a href="#/register"><small>belum punya akun ? <br/><i>not register yet ?</i></small></a>
                  <v-spacer></v-spacer>
                  <v-btn block color="success" @click="login" :loading="loading">Login</v-btn>                
                </v-card-actions>                   
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>        
      </v-content>  
    </div>
  </v-app>        
</template>

<script>
import config from '@/config';      
import moment from 'moment';    
import User   from '@/util/models/User';

export default {
  components: {   
  },      
  data: () => ({
    color:config.color,
    loading: false,    
    show3: false,
    captcha:null,
    model: {
      username: '',
      password: '',
      captcha : null
    },
    token:null
  }),  
  mounted: function(){      
      this.getCaptcha(); 

      if(this.$route.query['access-token']){
          this.loginByToken(this.$route.query['access-token']);
      }
  },
  methods: {
    getCaptcha(){        
        this.captcha = null;
        User.captcha().then(res=>{            
            if(res.status === 200){                
                this.captcha = res.data;
            }
        });
    },
    
    async login() {
        this.loading = true;
        const response = await User.login(this.model.username, this.model.password, this.model.captcha);        
        if(response.status == 200){        
            this.token = response.data;
            User.set(this.token);            
            window.getApp.$emit('showSnackbar', {text:'Login Successfully. Redirecting...',show:true,color:'green'});        
            setTimeout(() => {this.$router.push('/dashboard');}, 1000);
        } else {
            var msg = response.data? '#'+response.data.status+' => '+response.data.message:
                'Something happened in setting up the request that triggered an Error.';             
            window.getApp.$emit('showSnackbar', {show:true,text: msg,color:'red'});
        }
        setTimeout(() => {this.loading = false;}, 1000);
    },

    async loginByToken(token) {
        this.loading = true;
        const response = await User.loginByToken(token);        
        if(response.status == 200){        
            this.token = response.data;
            User.set(this.token);            
            window.getApp.$emit('showSnackbar', {text:'Login Successfully. Redirecting...',show:true,color:'green'});        
            setTimeout(() => {this.$router.push('/dashboard');}, 1000);
        } else {
            var msg = response.data? '#'+response.data.status+' => '+response.data.message:
                'Something happened in setting up the request that triggered an Error.';             
            window.getApp.$emit('showSnackbar', {show:true,text: msg,color:'red'});
        }
        setTimeout(() => {this.loading = false;}, 1000);
    },

    
    openSetting(){
        window.getApp.$emit('APP_OPEN_DIALOG_SETTING');        
    }
  },  
};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
